export const COLUMNS_PREFERENCES_KEY = 'employees_visible_columns';
export const EMPTY_SELECT_VALUE = '__EMPTY__';

export const COLUMN_DEFINITIONS = [
  { id: 'select',              labelKey: 'employeesPage.columns.select',             visible: true,  fixed: true },
  { id: 'registration_number', labelKey: 'employeesPage.columns.registrationNumber', visible: true,  defaultVisible: true },
  { id: 'last_name',           labelKey: 'employeesPage.columns.lastName',           visible: true,  defaultVisible: true },
  { id: 'first_name',          labelKey: 'employeesPage.columns.firstName',          visible: true,  defaultVisible: true },
  { id: 'email',               labelKey: 'employeesPage.columns.email',              visible: true,  defaultVisible: true },
  { id: 'phone_number',        labelKey: 'employeesPage.columns.phone',              visible: true,  defaultVisible: true },
  { id: 'birth_date',          labelKey: 'employeesPage.columns.birthDate',          visible: false, defaultVisible: false },
  { id: 'job_name',            labelKey: 'employeesPage.columns.jobName',            visible: true,  defaultVisible: true },
  { id: 'department_name',     labelKey: 'employeesPage.columns.departmentName',     visible: true,  defaultVisible: true },
  { id: 'site_name',           labelKey: 'employeesPage.columns.siteName',           visible: false, defaultVisible: false },
  { id: 'status',              labelKey: 'employeesPage.columns.status',             visible: true,  defaultVisible: true },
  { id: 'contract_type',       labelKey: 'employeesPage.columns.contractType',       visible: false, defaultVisible: false },
  { id: 'role',                labelKey: 'employeesPage.columns.role',               visible: false, defaultVisible: false },
  { id: 'badge_number',        labelKey: 'employeesPage.columns.badgeNumber',        visible: true,  defaultVisible: true },
  { id: 'fingerprint_id',      labelKey: 'employeesPage.columns.fingerprintId',      visible: false, defaultVisible: false },
  { id: 'face_id',             labelKey: 'employeesPage.columns.faceId',             visible: false, defaultVisible: false },
  { id: 'card_id',             labelKey: 'employeesPage.columns.cardId',             visible: false, defaultVisible: false },
  { id: 'supervisor_name',     labelKey: 'employeesPage.columns.supervisorName',     visible: false, defaultVisible: false },
  { id: 'coach_name',          labelKey: 'employeesPage.columns.coachName',          visible: false, defaultVisible: false },
  { id: 'mentor_name',         labelKey: 'employeesPage.columns.mentorName',         visible: false, defaultVisible: false },
  { id: 'hire_date',           labelKey: 'employeesPage.columns.hireDate',           visible: false, defaultVisible: false },
  { id: 'contract_end_date',   labelKey: 'employeesPage.columns.contractEndDate',    visible: false, defaultVisible: false },
  { id: 'created_at',          labelKey: 'employeesPage.columns.createdAt',          visible: false, defaultVisible: false },
  { id: 'updated_at',          labelKey: 'employeesPage.columns.updatedAt',          visible: false, defaultVisible: false },
  { id: 'is_postier',          labelKey: 'employeesPage.columns.isPostier',          visible: false, defaultVisible: false },
  { id: 'regime',              labelKey: 'employeesPage.columns.regime',             visible: false, defaultVisible: false },
  { id: 'actions',             labelKey: 'employeesPage.columns.actions',            visible: true,  fixed: true },
];

export const FILTER_FIELDS = [
  { id: 'registration_number', labelKey: 'employeesPage.columns.registrationNumber', type: 'string' },
  { id: 'last_name',           labelKey: 'employeesPage.columns.lastName',           type: 'string' },
  { id: 'first_name',          labelKey: 'employeesPage.columns.firstName',          type: 'string' },
  { id: 'email',               labelKey: 'employeesPage.columns.email',              type: 'string' },
  { id: 'phone_number',        labelKey: 'employeesPage.columns.phone',              type: 'string' },
  { id: 'badge_number',        labelKey: 'employeesPage.columns.badgeNumber',        type: 'string' },
  { id: 'job_name',            labelKey: 'employeesPage.columns.jobName',            type: 'string' },
  { id: 'department_name',     labelKey: 'employeesPage.columns.departmentName',     type: 'string' },
  { id: 'site_name',           labelKey: 'employeesPage.columns.siteName',           type: 'string' },
  {
    id: 'status', labelKey: 'employeesPage.columns.status', type: 'enum',
    options: [
      { value: 'ACTIVE',    labelKey: 'employeesPage.status.active' },
      { value: 'INACTIVE',  labelKey: 'employeesPage.status.inactive' },
      { value: 'SUSPENDED', labelKey: 'employeesPage.status.suspended' },
      { value: 'ARCHIVED',  labelKey: 'employeesPage.status.archived' },
    ],
  },
  {
    id: 'contract_type', labelKey: 'employeesPage.columns.contractType', type: 'enum',
    options: [
      { value: 'PERMANENT',  labelKey: 'employeesPage.contractType.permanent' },
      { value: 'TEMPORARY',  labelKey: 'employeesPage.contractType.fixedTerm' },
      { value: 'INTERNSHIP', labelKey: 'employeesPage.contractType.internship' },
      { value: 'FREELANCE',  labelKey: 'employeesPage.contractType.freelance' },
    ],
  },
  {
    id: 'role', labelKey: 'employeesPage.columns.role', type: 'enum',
    options: [
      { value: 'EMPLOYEE',   labelKey: 'employeesPage.roles.employee' },
      { value: 'SUPERVISOR', labelKey: 'employeesPage.roles.supervisor' },
      { value: 'MANAGER',    labelKey: 'employeesPage.roles.manager' },
      { value: 'HR',         labelKey: 'employeesPage.roles.hr' },
      { value: 'ADMIN',      labelKey: 'employeesPage.roles.admin' },
    ],
  },
  {
    id: 'regime', labelKey: 'employeesPage.labels.regime', type: 'enum',
    options: [
      { value: 'NORMAL', labelKey: 'employeesPage.regime.normal' },
      { value: 'SHIFT',  labelKey: 'employeesPage.regime.shift' },
      { value: 'FLEX',   labelKey: 'employeesPage.regime.flex' },
    ],
  },
  { id: 'is_postier',        labelKey: 'employeesPage.columns.isPostier',       type: 'boolean' },
  { id: 'hire_date',         labelKey: 'employeesPage.columns.hireDate',        type: 'date' },
  { id: 'contract_end_date', labelKey: 'employeesPage.columns.contractEndDate', type: 'date' },
  { id: 'birth_date',        labelKey: 'employeesPage.columns.birthDate',       type: 'date' },
  { id: 'created_at',        labelKey: 'employeesPage.columns.createdAt',       type: 'date' },
  { id: 'updated_at',        labelKey: 'employeesPage.columns.updatedAt',       type: 'date' },
];
